
import type { CheckoutLocationState } from "@/app/core/TokensPayment/checkOutComp/subscribe/shared/checkoutTypes";

export class CheckoutPageController {

  resolveProduct(state: CheckoutLocationState | null): CheckoutLocationState {
    if (state) return state;
    return {
      productType: "subscription",
      productCode: "fallback-subscription",
      productId: "premium",
      productName: "Premium",
      priceRub: 499,
      durationLabel: "месяц",
    };
  }

  formatPrice(price: number): string {
    const hasFraction = !Number.isInteger(price);
    return `${new Intl.NumberFormat("ru-RU", {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: hasFraction ? 2 : 0,
    }).format(price)}₽`;
  }

  formatMinorAmount(amountMinor: number, currency: string): string {
    const normalizedCurrency = currency.trim().toUpperCase();
    if (normalizedCurrency === "RUB") {
      return this.formatPrice(amountMinor / 100);
    }

    return `${new Intl.NumberFormat("ru-RU", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amountMinor)} ${normalizedCurrency}`;
  }
}

